// Neu (SPEC 03 §7.1) — Rechte-Abfrage für die Oberfläche. Knöpfe für fehlende Rechte werden
// NICHT gezeichnet; der Server bleibt der Durchsetzer (403 „Dafür fehlt dir das Recht.“).
import type { Ich, Recht } from "../api/typen";

/** hatRecht(ich, V, r) = ich.verfahren.find(v => v.code === V)?.rechte.includes(r); `verwalten` = Rolle admin. */
export function hatRecht(ich: Ich | null | undefined, V: string | null | undefined, r: Recht): boolean {
  if (!ich) return false;
  if (r === "verwalten" && ich.rolle === "admin") return true;
  if (!V) return false;
  return ich.verfahren.find((v) => v.code === V)?.rechte.includes(r) ?? false;
}

/** Die Verwaltungsseiten (`/admin`) verlangen die Rolle admin (02 §1.7). */
export function istAdmin(ich: Ich | null | undefined): boolean {
  return ich?.rolle === "admin";
}

/** Verfahren-Code aus einem Beleg-/Bogen-/Mengen-Code: "MU26-017-2c" → "MU26" (03 §7.1). */
export function verfahrenAusCode(ref: string | null | undefined): string | null {
  if (!ref) return null;
  const m = /^([A-Z]{2,5}\d{2})(?=-)/.exec(ref);
  return m ? m[1]! : null;
}
